import { useEffect, useState } from "react";
import { useAuthContext } from "../context/AuthContext";
import { useSocketContext } from "../context/SocketContext";
import { getSocketWorkspace } from "../utils/socketWorkspace";
import { buildTeamPresenceXpro4Payload } from "../utils/teamPresenceTelemetry";

const EMIT_INTERVAL_MS_VISIBLE = 20_000;
const EMIT_INTERVAL_MS_HIDDEN = 45_000;

/**
 * Emite `users` com telemetria Xpro 4 em **toda** aba autenticada, em qualquer rota.
 * O hook `useTeamSocketPresence` só escuta — sem isso, só a aba que montava o hook (ex.: dashboard) aparecia no socket.
 */
export default function TeamPresenceSocketEmitter() {
  const { socket } = useSocketContext();
  const { userData } = useAuthContext();
  const [emitIntervalMs, setEmitIntervalMs] = useState(EMIT_INTERVAL_MS_VISIBLE);

  useEffect(() => {
    const onVis = () => setEmitIntervalMs(document.hidden ? EMIT_INTERVAL_MS_HIDDEN : EMIT_INTERVAL_MS_VISIBLE);
    onVis();
    document.addEventListener("visibilitychange", onVis);
    return () => document.removeEventListener("visibilitychange", onVis);
  }, []);

  useEffect(() => {
    if (!socket) return undefined;

    const emitUsers = () => {
      let workspace = getSocketWorkspace();
      if (!workspace) {
        try {
          const company = localStorage.getItem("company");
          if (company) workspace = `${company}.xpro.me`;
        } catch {
          /* ignore */
        }
      }
      const id = userData?.id;
      if (!workspace || id == null) return;
      const name = userData?.nome || userData?.name || "";
      socket.emit("users", buildTeamPresenceXpro4Payload({ id, name, workspace }));
    };

    emitUsers();
    const interval = setInterval(emitUsers, emitIntervalMs);
    return () => clearInterval(interval);
  }, [socket, userData?.id, userData?.nome, userData?.name, emitIntervalMs]);

  return null;
}
